import { render, staticRenderFns } from "./setType5Template.vue?vue&type=template&id=a1338054&scoped=true"
import script from "./setType5Template.vue?vue&type=script&lang=js"
export * from "./setType5Template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1338054",
  null
  
)

export default component.exports